import { useState, useEffect, useRef } from "react";
import "../../../../../css/AML/Tooltip/AMLTooltip.css";

const WarningTooltip = ({ children, text, position = "top" }) => {
  const [open, setOpen] = useState(false);
  const [locked, setLocked] = useState(false);
  const ref = useRef(null);

  // Click outside closes + unlocks
  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setLocked(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div
      className="TooltipContainer"
      ref={ref}
      onMouseEnter={() => setOpen(true)} // hover open
      onMouseLeave={() => {
        if (!locked) setOpen(false); // only close if not clicked
      }}
      onClick={(e) => {
        e.stopPropagation();
        setLocked(true); // lock open
        setOpen(true);
      }}
    >
      {children}

      {open && (
        <div className={`TooltipBubble Warning Tooltip-${position}`}>
          <div className="AML-Text-Body">
            {typeof text === "string" ? text : text}
          </div>
          <span className={`TooltipArrow Warning TooltipArrow-${position}`} />
        </div>
      )}
    </div>
  );
};

export default WarningTooltip;
